export const selectCurrentPage = (state) => state.products.page;
export const selectShowLoadMore = (state) => state.products.showLoadMore;
export const selectProducts = (state) => {
  return state.products.values.filter((item) => item.product.images.length > 0);
};
export const selectIsFetchingProducts = (state) => state.products.pendingGetProducts;
